export const BRANDS = [
  {
    slug: 'ethnc',
    name: 'Ethnc',
    href: '/brands/ethnc',
    description: 'Color, culture, and confidence in every thread.',
  },
] as const;

const BRAND_DISPLAY_NAMES: Record<string, string> = {
  ethnc: 'Ethnc',
  khaadi: 'Khaadi',
  sapphire: 'Sapphire',
  studiosy: 'StudioSY',
  qalamkar: 'Qalamkar',
  beechtree: 'Beechtree',
  lulusar: 'Lulusar',
};

export function getBrandDisplayName(slug?: string | null): string {
  if (!slug) return 'Ethnc';
  return BRAND_DISPLAY_NAMES[slug.toLowerCase()] ?? slug.replace(/-/g, ' ');
}